import React from 'react';
import { Link } from 'react-router-dom';
import Spline from '@splinetool/react-spline';
import { ArrowRight, Zap, Clock, Shield } from 'lucide-react';
import { services, companyInfo } from '../mock';
import { SEO } from '../components/SEO';

export const Home = () => {
  return (
    <div className="dark-container">
      <SEO 
        title="NEXEN DIGITAL - Best Website Development & App Development Company in Bhubaneswar"
        description="Leading Website Development and App Development Company in Bhubaneswar, Odisha. We deliver AI-powered web development, mobile app development, and custom software solutions. Get professional website & app development services in Bhubaneswar."
        keywords="website development in bhubaneswar, app development in bhubaneswar, web development company bhubaneswar, mobile app development bhubaneswar, software development bhubaneswar, AI development, digital agency bhubaneswar, best web developers bhubaneswar, odisha"
      />
      {/* Hero Section with Spline */}
      <section className="hero-section" style={{ minHeight: 'calc(100vh - 80px)', display: 'flex', alignItems: 'center', position: 'relative', overflow: 'visible', padding: '40px 0' }}>
        <div className="hero-container" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', maxWidth: '1400px', margin: '0 auto', gap: '40px' }}>
          {/* Left Content */}
          <div className="hero-content" style={{ flex: 1, zIndex: 2 }}>
            <h1 className="display-huge" style={{ marginBottom: '24px', color: '#FFFFFF' }}>
              Build Digital Products with <span style={{ color: '#00FFD1' }}>AI-First</span> Approach
            </h1>
            <p className="body-large" style={{ marginBottom: '40px', color: 'rgba(255, 255, 255, 0.85)', maxWidth: '600px' }}>
              Transform your ideas into reality with cutting-edge development powered by artificial intelligence. We deliver faster, smarter, and better.
            </p>
            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
              <Link to="/contact" className="btn-primary">
                Get Started
                <ArrowRight size={20} />
              </Link>
              <Link to="/portfolio" className="btn-secondary">
                View Our Work
              </Link>
            </div>
          </div>

          {/* Right Side - Spline 3D */}
          <div className="hero-spline" style={{ flex: 1, height: '700px', width: '700px', overflow: 'visible', position: 'relative' }}>
            <Spline scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode" />
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section style={{ padding: '100px 0' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <h2 className="display-large" style={{ textAlign: 'center', marginBottom: '60px', color: '#FFFFFF' }}>
            Why Choose <span style={{ color: '#00FFD1' }}>NEXEN DIGITAL</span>
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '40px' }}>
            <div style={{ background: '#121212', padding: '40px', border: '1px solid rgba(255, 255, 255, 0.25)' }}>
              <Zap size={48} style={{ color: '#00FFD1', marginBottom: '20px' }} />
              <h3 className="heading-2" style={{ marginBottom: '16px', color: '#FFFFFF' }}>AI-Powered Development</h3>
              <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
                Leverage cutting-edge AI to accelerate development and enhance quality at every stage.
              </p>
            </div>
            <div style={{ background: '#121212', padding: '40px', border: '1px solid rgba(255, 255, 255, 0.25)' }}>
              <Clock size={48} style={{ color: '#00FFD1', marginBottom: '20px' }} />
              <h3 className="heading-2" style={{ marginBottom: '16px', color: '#FFFFFF' }}>Fast Delivery</h3>
              <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
                AI-first approach enables us to deliver projects faster without compromising on quality.
              </p>
            </div>
            <div style={{ background: '#121212', padding: '40px', border: '1px solid rgba(255, 255, 255, 0.25)' }}>
              <Shield size={48} style={{ color: '#00FFD1', marginBottom: '20px' }} />
              <h3 className="heading-2" style={{ marginBottom: '16px', color: '#FFFFFF' }}>Quality Assured</h3>
              <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
                Every project undergoes rigorous testing and quality checks to ensure excellence.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section style={{ padding: '100px 0', background: '#121212' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <h2 className="display-large" style={{ textAlign: 'center', marginBottom: '20px', color: '#FFFFFF' }}>
            Our <span style={{ color: '#00FFD1' }}>Services</span>
          </h2>
          <p className="body-large" style={{ textAlign: 'center', marginBottom: '60px', color: 'rgba(255, 255, 255, 0.85)', maxWidth: '700px', margin: '0 auto 60px' }}>
            We offer comprehensive digital solutions powered by AI technology
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '40px' }}>
            {services.map((service) => (
              <div key={service.id} style={{ background: '#000000', padding: '40px', border: '1px solid rgba(255, 255, 255, 0.25)', transition: 'all 0.4s ease-in-out' }} className="service-card">
                <h3 className="heading-1" style={{ marginBottom: '16px', color: '#FFFFFF' }}>
                  {service.title}
                </h3>
                <p className="body-medium" style={{ marginBottom: '24px', color: 'rgba(255, 255, 255, 0.85)' }}>
                  {service.description}
                </p>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {service.features.slice(0, 3).map((feature, idx) => (
                    <li key={idx} style={{ fontSize: '16px', color: '#FFFFFF', marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                      <span style={{ position: 'absolute', left: 0, color: '#00FFD1' }}>✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: '60px' }}>
            <Link to="/services" className="btn-primary">
              View All Services
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ padding: '100px 0' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '40px', textAlign: 'center' }}>
            {companyInfo.stats.map((stat, idx) => (
              <div key={idx}>
                <div className="display-large" style={{ color: '#00FFD1', marginBottom: '12px' }}>
                  {stat.value}
                </div>
                <div className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ padding: '100px 0', background: '#121212' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h2 className="display-large" style={{ marginBottom: '24px', color: '#FFFFFF' }}>
            Ready to Build Something <span style={{ color: '#00FFD1' }}>Amazing?</span>
          </h2>
          <p className="body-large" style={{ marginBottom: '40px', color: 'rgba(255, 255, 255, 0.85)' }}>
            Let's discuss how we can help bring your digital vision to life with our AI-first approach.
          </p>
          <Link to="/contact" className="btn-primary">
            Start Your Project
            <ArrowRight size={20} />
          </Link>
        </div>
      </section>
    </div>
  );
};